<script>
import { useAlert } from 'dashboard/composables';
import IssueForm from '../IssueForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    IssueForm,
    PageHeader,
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  methods: {
    async createIssue(data) {
      try {
        const issue = await this.$store.dispatch('issues/create', {
          ...data,
        });

        router.replace({
          name: 'settings_issues_add_agents',
          params: {
            page: 'new',
            issueId: issue.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('ISSUES_SETTINGS.ISSUE_FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('ISSUES_SETTINGS.CREATE_FLOW.CREATE.TITLE')"
      :header-content="$t('ISSUES_SETTINGS.CREATE_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <IssueForm
        :on-submit="createIssue"
        :submit-in-progress="false"
        :submit-button-text="$t('ISSUES_SETTINGS.FORM.SUBMIT_CREATE')"
      />
    </div>
  </div>
</template>
